angular.module('gym.invoices').controller('UpdateInvoiceApprovalDateCtrl', ["$scope", "$rootScope", "$modalInstance", "$http", "flash", "invoice", function($scope, $rootScope, $modalInstance, $http, flash, invoice) {
  $scope.gym = $rootScope.gym;
  $scope.params = {
    newApprovalDate: invoice.approval_date
  };
  $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
  return $scope.saveNewApprovalDate = function() {
    var params, url;
    $scope.editApprovalDateLoading = true;
    url = `/gyms/${$scope.gym.id}/invoices/${invoice.id}/update_approval_date`;
    params = {
      invoice: {
        approval_date: $scope.params.newApprovalDate
      }
    };
    return $http.put(url, params).then(function(response) {
      flash.success = "Updated successfully";
      return $modalInstance.close(response.data);
    }, function(response) {
      flash.error = "There was an error processing the request.";
      return $scope.editApprovalDateLoading = true;
    });
  };
}]);
